export default __webpack_public_path__ + "static/media/Witbooker_AI_ES.e2bb1807.png";